export function callFlowImageDisplayName(item: any): string | undefined {
  if (item?.imageName) return String(item.imageName);
  const url = item?.imageURL;
  if (!url) return undefined;
  const seg = String(url).split("/").filter(Boolean);
  return seg.length ? seg[seg.length - 1] : String(url);
}

export function buildCallFlowSavePayload(callFlow: any[]) {
  return {
    callFlow: callFlow.map((item: any) => {
      const row: Record<string, unknown> = {
        question: (item.objection ?? item.question ?? "").toString(),
        category: item.category,
        subtext: item.subtext ?? "",
      };
      if (item.imageURL) {
        row.imageURL = item.imageURL;
        const imageName = callFlowImageDisplayName(item);
        if (imageName) row.imageName = imageName;
      }
      return row;
    }),
  };
}
